import React, { useState } from 'react';

import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { ContactForm } from 'components/ContactForm/ContactForm';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { getTenantId } from 'utils/tenantUtil';

import './css/GenericModal.scss';

const DialogTitle = (props) => {
  const { children, modalclose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className="dialog" {...other}>
      <SubTitle text={children} className={`dialog__title ${!modalclose && 'no-icon'}`} notFramed />
      {modalclose ? (
        <IconButton aria-label="close" onClick={modalclose}>
          <CancelIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

DialogTitle.propTypes = {
  children: PropTypes.any,
  modalclose: PropTypes.func,
};

DialogTitle.defaultProps = {
  children: null,
  modalclose: null,
};

const DialogSubtitle = (props) => {
  const { children, ...other } = props;
  return (
    <MuiDialogContent {...other}>
      <DialogContentText>{children}</DialogContentText>
    </MuiDialogContent>
  );
};

DialogSubtitle.propTypes = {
  children: PropTypes.any,
};

DialogSubtitle.defaultProps = {
  children: null,
};

export const GenericModal = ({ data, openModal, closeModal }) => {
  const [visible, setVisibile] = useState(false);

  const visibility = () => {
    setVisibile(!visible);
    document.getElementById('visible').style.visibility = 'hidden';
  };

  return openModal
    ? ReactDOM.createPortal(
        <Dialog
          className={getTenantId()}
          id="visible"
          fullWidth
          max-height="558px"
          open={openModal}
          onClose={closeModal}
          aria-labelledby="form-dialog-title">
          {data.title && <DialogTitle modalclose={closeModal}>{data.title}</DialogTitle>}
          {data.dummyNumber && (
            <DialogSubtitle>{`${data.subtitle} ${data.dummyNumber}`}</DialogSubtitle>
          )}
          <ContactForm email={data.email} modalclose={closeModal} visibility={visibility} />
        </Dialog>,
        document.body
      )
    : null;
};

GenericModal.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    dummyNumber: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  openModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
